import { render, staticRenderFns } from "./loadingBar.vue?vue&type=template&id=44c8c662&scoped=true"
import script from "./loadingBar.vue?vue&type=script&lang=js"
export * from "./loadingBar.vue?vue&type=script&lang=js"
import style0 from "./loadingBar.vue?vue&type=style&index=0&id=44c8c662&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c8c662",
  null
  
)

export default component.exports